import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';
import parseDom from 'html-dom-parser';
import BackBtn from '../../components/UI/BackBtn';
import NewsReadPost from '../../components/News/Read/Post';
import useAPI from '../../hooks/useAPI';

import '../Page.less';

export default function NewsRead() {
  const { id } = useParams();
  const api = useAPI();

  const [post, setPost] = useState({ post: '' });

  const handleFileOpen = async (item) =>
    await api.download(`/minioFiles/download/${item.id}`, item.name);

  const parseOptions = {
    replace: (domNode) => {
      const nodeData = parseDom(domNode?.data || '');
      const hasFileDownloadTag = nodeData.find((node) => node?.attribs?.filedownload);

      if (domNode?.attribs?.filedownload) {
        return (
          <a
            className="" // нужно добавить хоть какой-то класс, иначе стили сотрутся https://github.com/twbs/bootstrap/issues/19402
            style={{ cursor: 'pointer' }}
            onClick={() =>
              handleFileOpen({
                id: domNode.attribs.id,
                type: 'file',
                name: domNode.attribs.filename,
              })}
          >
            {domNode.children[0]?.data}
          </a>
        );
      }
      if (hasFileDownloadTag) {
        return <>{domToReact(nodeData, parseOptions)}</>;
      }
    },
  };

  useEffect(async () => {
    const respPost = await api.get(`/news/${id}`);
    if (respPost && !respPost.error) {
      setPost(respPost);
    }
  }, []);

  return (
    <section className="page news-page">
      <div style={{ padding: '3em 5em' }}>
          <Col sm={12} xxl={9}>
            <BackBtn />
            <section style={{ marginTop: '30px' }}>
              {post && (
                <NewsReadPost
                  header={post.header}
                  date={post.uploadDate}
                  tags={post.tags}
                  imageId={post.imageFileId}
                  content={parse(post.post, parseOptions)}
                />
              )}
            </section>
          </Col>
      </div>
    </section>
  );
}
